<script>

    import {scrollToTop} from "../core/utils.js";

    export let hideScrollToTop = false;
    export let section;

</script>

<style>
    .section-title-container {
        padding-block-start: 1em;
    }
    .section-title {
        font-size: var(--fs-150);
        margin-block-start: 0;
        margin-bottom: .25em;
        padding: 0 1.25rem;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .section-title small {
        font-size: .8rem;
    }
    .section ~ .section-title {
        padding-top: 1rem;
    }
    .section-subtitle {
        font-weight: 400;
        padding: 0 1.25rem;
        font-size: var(--fs-100);
        margin-bottom: 1rem;
        color: #5f5f5f;
    }
</style>

<div class="section-title-container">
    {#if (section.title) }
        <h3 id={'s' + section.id} class="section-title">
            <span>{section.title}</span>
            {#if (!hideScrollToTop) }
                <small class="pointer" on:click={() => scrollToTop()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ArrowUp"><path d="M12 20V4"/><path d="M5 11l7-7 7 7"/></svg>
                </small>
            {/if}
        </h3>
    {/if}

    {#if (section.subTitle) }
        <div class="section-subtitle">{ section.subTitle }</div>
    {/if}
</div>

